import React from 'react';

// IB-677 rework — compact ~110px profile donut with a legend beside it (wireframe
// .donutwrap). Rendered as a CSS conic-gradient rather than an Apex chart so it
// sizes deterministically to 110px and every category is labelled in the side
// legend — a single-category profile reads as a labelled ring, not a blank circle.
// segments: [{ value, colour, label }]  — colour is a raw hex (gradient needs a
// literal colour, not a Tailwind class).
export default function RadioDonut({ segments = [], total }) {
    const withValues = segments.filter((segment) => Number(segment.value) > 0);
    const sum = withValues.reduce((carry, segment) => carry + Number(segment.value), 0);

    if (!sum) {
        return <div className="tw-text-sm tw-text-charcoal-50">{$t('No data')}</div>;
    }

    let acc = 0;
    const stops = withValues
        .map((segment) => {
            const from = (acc / sum) * 100;
            acc += Number(segment.value);
            const to = (acc / sum) * 100;
            return `${segment.colour} ${from}% ${to}%`;
        })
        .join(', ');

    return (
        <div className="tw-flex tw-items-center tw-gap-4">
            <div className="tw-relative tw-shrink-0 tw-rounded-full" style={{ width: 110, height: 110, background: `conic-gradient(${stops})` }}>
                <div
                    className="tw-absolute tw-rounded-full tw-bg-white tw-flex tw-items-center tw-justify-center tw-text-center tw-text-xs tw-font-semibold tw-text-charcoal-75 tw-leading-tight"
                    style={{ inset: 20 }}
                >
                    {total}
                </div>
            </div>
            <div className="tw-flex tw-flex-col tw-gap-1.5 tw-text-xs tw-text-charcoal-75">
                {segments.map((segment, index) => (
                    <span key={index} className="tw-flex tw-items-center tw-gap-2">
                        <i className="tw-inline-block tw-h-2.5 tw-w-2.5 tw-rounded-sm tw-shrink-0" style={{ background: segment.colour }} />
                        {segment.label}
                    </span>
                ))}
            </div>
        </div>
    );
}
